import React from 'react';

import classnames from 'classnames';

import { OrderDetailsSelectedContentHeader } from './order-details-selected-content-header';
import { SelectedContentLayoutLoader } from '../layouts/selected-content-layout/selected-content-layout-loader';

import style from './order-details-selected-content.module.less';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.column1Sections]
 * @param {React.ReactNode} [props.column2Sections]
 * @param {React.ReactNode} [props.column3Sections]
 * @param {string} [props.headerClassName]
 * @param {React.ReactNode} [props.headerContent]
 * @param {React.ReactNode} props.fulfillmentPlannerSections
 * @param {React.ReactNode} props.primaryShipmentSections
 * @param {React.ReactNode} [props.rateCard]
 * @param {React.ReactNode} props.secondaryShipmentSections
 * @returns {JSX.Element}
 */
export const OrderDetailsSelectedContent = ({
  className,
  column1Sections,
  column2Sections,
  column3Sections,
  headerClassName,
  headerContent,
  primaryShipmentSections,
  fulfillmentPlannerSections,
  secondaryShipmentSections,
  rateCard = null,
}) => {
  const showHeaderRow = !!headerContent;

  return (
    <div className={classnames(style['order-details-selected-content'], { [style['no-header-row']]: !showHeaderRow }, className)}>
      {showHeaderRow && <OrderDetailsSelectedContentHeader className={headerClassName}>{headerContent}</OrderDetailsSelectedContentHeader>}
      <SelectedContentLayoutLoader
        column1Sections={column1Sections}
        column2Sections={column2Sections}
        column3Sections={column3Sections}
        fulfillmentPlannerSections={fulfillmentPlannerSections}
        primaryShipmentSections={primaryShipmentSections}
        rateCard={rateCard}
        secondaryShipmentSections={secondaryShipmentSections}
      />
    </div>
  );
};
